const {palette} = require('./palette');

export class ColorsService {
  install(Vue: any, options: any) { 
    Vue.prototype.$colors = {
      ...palette
    };
  }
}
  
export default new ColorsService();